<script setup lang="ts">
import { navigationActions } from "@/action/navigationActions";
import { toggleActions } from "@/action/toggleActions";
import { action } from "@/components/action/action";
import DropdownMenu from "@/components/ui/DropdownMenu/DropdownMenu.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import MenuList from "@/components/ui/MenuList/MenuList.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import MenuListItems from "@/components/ui/MenuList/MenuListItems.vue";
</script>

<template>
  <DropdownMenu width="md" :offset="{ top: 14 }">
    <template #trigger="{ isOpen }">
      <IconButton
        id="facilitation-menu-trigger"
        data-dropdown-trigger
        icon="general/facilitation"
        :activated="isOpen"
        :text="$t('action.facilitation')"
        :aria-expanded="isOpen"
        aria-haspopup="menu"
        aria-controls="facilitation-dropdown"
        data-testid="facilitation-button"
      />
    </template>
    <MenuList>
      <MenuListItems id="facilitation-dropdown" v-keyboard-nav role="menu">
        <MenuListItem v-bind="action(navigationActions.goToPlanReadout)" />
        <MenuListItem v-bind="action(toggleActions.showTimer)" />
        <MenuListItem v-bind="action(toggleActions.showConfidenceVoteModal)" />
      </MenuListItems>
    </MenuList>
  </DropdownMenu>
</template>
